export default "__VITE_ASSET__ugVosnYR__$_?no-inline__"